﻿import config from "../config"
const baseUrl = config.base_url + "sdd_ns_lib/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "post",
    },
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },

}

